export const VERSION_OVERRIDE = {
    '1-15-001': 'Infernal Invasion (1.15.001)',
    '1-14-00': 'Eclypse (1.14.00)',
    '1-13-00': 'Thornwind Pass (1.13.00)',
    '1-12-00': 'Siege of Shadows (1.12.00)',
    '1-11-00': 'Meta Progression (1.11.00)',
    '1-10-00': 'Catalyst (1.10.00)',
    '1-9-00': 'Onyx Cathedral (1.9.00)',
    '1-8-00': 'Masks of Misery (1.8.00)',
    '1-7-01': 'Trial of the Sunforge (1.7.01)',
    '1-6-00': 'Infinitum (1.6.00)'
}

export const CARD_TYPE = [
    'Melee',
    'Magic',
    'Ranged',
    'Utility',
    'Divine',
    'Move',
    'Corruption',
    'Monster',
    ''
];

export const CARD_CATEGORY = [
    'Action',
    'Item',
    'Artifact',
    'Conjuration',
    'Enchantment',
    'Basic Attack',
    'Summon',
    'Performance',
    'Form',
    'Hymn',
    'Talent',
    'Revelation',
    'Affix',
    'Attunement',
    'Equipment',
    'Code',
    'Ingredient',
    'Path',
    'Location',
    'Offering'
];

export const CARD_RARITY = [
    'Common',
    'Uncommon',
    'Rare',
    'Legendary',
    'Monster',
    'Epic',
    'Mythic',
    'Ultra'
];

export const BANNER_COLOR = [
    'None',
    'Green',
    'Blue',
    'Red',
    'Purple',
    'Brown',
    'Aqua',
    'White',
    'Gold',
    'Black',
    'Orange',
    'Monster'
];

export const DIFFICULTY = [
    'Normal',
    'Challenging',
    'Hard',
    'Impossible'
];

export const GAME_TRIGGERS = {
    'None': 0,
    'PlayAction': 1,
    'Pause': 2,
    'GainEnergy': 3,
    'SpendEnergy': 4,
    'DealtDamage': 5,
    'CalculateIncomingDamage': 6,
    'GainHealth': 7,
    'GainStatusStack': 8,
    'LoseStatusStack': 9,
    'Shuffle': 10,
    'Kill': 11,
    'Draw': 12,
    'Bury': 13,
    'Discard': 14,
    'Remove': 15,
    'Conjure': 16,
    'Return': 17,
    'StartCombat': 18,
    'StartPhase': 19,
    'EnergyPhase': 20,
    'DrawPhase': 21,
    'PlayPhase': 22,
    'DiscardPhase': 23,
    'EndTurnPhase': 24,
    'EnemyPhase': 25,
    'VictoryPhase': 26,
    'NoCombat': 27,
    'GainGold': 28,
    'GainFood': 29,
    'GainRestingHealing': 30,
    'RollTreasure': 31,
    'CalculateGoldCost': 32,
    'CalculateOutgoingDamage': 33,
    'CalculateCardCost': 34,
    'ResolveDamage': 35,
    'AcquireCard': 36,
    'RemoveCard': 37,
    'ActivateWeapon': 38,
    'EnemyPlaysAction': 39,
    'GainUniqueStatus': 40,
    'EncounterOpportunity': 41,
    'UpgradeAction': 42,
    'ImbueEnchantment': 43,
    'EndAction': 44,
    'Rewards': 45,
    'EnterCombat': 46,
    'VisitCampsite': 47,
    'Death': 48,
    'PickEvent': 49,
    'CriticalHit': 50,
    'TakeStatusDamage': 51,
    'AfterTakenDamage': 52,
    'EncounterShrine': 53,
    'Reshuffle': 54,
    'Shout': 55,
    'CompanionPlays': 56,
    'EndRun': 57,
    'FinalVictory': 58,
    'FinalDefeat': 59,
    'Highscore': 60,
    'ReachCanto': 61,
    'Perform': 62,
    'Playerdeath': 63,
    'Shapechange': 64,
    'Gainsouls': 65,
    'Deepwound': 66,
    'FinishPerformance': 67,
    'CardReward': 68,
    'EndDamage': 69,
    'AfterHealing': 70,
    'EnemyEndsAction': 71,
    'Reveal': 72,
    'SpendCharge': 73,
    'InflictStatus': 74,
    'InflictUniqueStatus': 75,
    'InflictDamage': 76,
    'QueueAction': 77,
    'InflictStatusDamage': 78,
    'ResolveDamageTaken': 79,
    'SummonClone': 80,
    'ChangeTide': 81,
    'AttuneTrigger': 82,
    'ShuffleCard': 83,
    'EnterStance': 84,
    'GainEnchantment': 85,
    'IncomingDamage': 86,
    'LoseGold': 87,
    'AddCardToEnemyDeck': 88,
    'Interrupt': 89,
    'ResetCard': 90,
    'PostAction': 91,
    'StartGame': 92,
    'BelowZeroHealth': 93,
    'UpdateAreaSpecial': 94,
    'Defile': 95,
    'Foretell': 96,
    'ChangeMaxHealth': 97,
    'LoseStatus': 98,
    'GainAffliction': 99,
    'MutateCard': 100,
    'Reaping': 101,
    'EnemyGainsStatus': 102
};

export const CONDITION_VALUE = {
    'None': 0,
    'MyHealth': 1,
    'OtherHealth': 2,
    'ActionType': 3,
    'ActionCategory': 4,
    'StatusOnSelf': 5,
    'StatusOnOpponent': 6,
    'TypeOfEnemyCardInHand': 7,
    'Chance': 8,
    'IsBoss': 9,
    'CardsInDeckTotal': 10,
    'CardsInGraveyard': 11,
    'CardsBurned': 12,
    'CardsInDeckRemaining': 13,
    'CardsPlayedThisTurn': 14,
    'CategoryPlayedThisTurn': 15,
    'CategoryPlayedLastTurn': 16,
    'TypePlayedThisTurn': 17,
    'TypePlayedLastTurn': 18,
    'CategoryPlayedByEnemy': 19,
    'TypePlayedByEnemy': 20,
    'CardsPlayedLastTurn': 21,
    'CardsPlayedThisCombat': 22,
    'HealthGainedThisTurn': 23,
    'DamageTakenThisTurn': 24,
    'AnyValue': 25,
    'Ambush': 26,
    'StatusType': 27,
    'CurrentCardIsConjured': 28,
    'StatusCategory': 29,
    'myDeckContains': 30,
    'otherDeckContains': 31,
    'CurrentPhase': 32,
    'EnchantmentStacks': 33,
    'EnemyTurn': 34,
    'EnergyType': 35,
    'EnemyType': 36,
    'Flanking': 37,
    'IsEven': 38,
    'IsOdd': 39,
    'LastChanceSuccess': 40,
    'EnchantmentOnOther': 41,
    'Frenzy': 42,
    'Bloodlust': 43,
    'HasPreviousCombat': 44,
    'Continuity': 45,
    'Finale': 46,
    'Flow': 47,
    'Cascade': 48,
    'Shout': 49,
    'Corrupted': 50,
    'Performing': 51,
    'Precision': 52,
    'Unscathed': 53,
    'EnchantmentOnSelf': 54,
    'InCombat': 55,
    'PlayerFirstTurn': 56,
    'LastEnergySpend': 57,
    'CardContainsKeyword': 58,
    'Balance': 59,
    'Scholar': 60,
    'CardRarity': 61,
    'CardInEnemyDeck': 62,
    'DamageIsPiercing': 63,
    'Ascended': 64,
    'InSunforge': 65,
    'Synergy': 66,
    'Empower': 67,
    'Imprints': 68,
    'CombatDeckContains': 69,
    'DamageType': 70,
    'DiscardContains': 71,
    'Suffix': 72,
    'Attuned': 73,
    'IsOneUse': 74,
    'IsUnique': 75,
    'IsPersistent': 76,
    'Channeling': 77,
    'DeckContainsNoDuplicates': 78,
    'DeckContainsOnlyCardsOfRarity': 79,
    'DeckContainsOnlyCardsOfType': 80,
    'EnchantmentType': 81,
    'HasTalent': 82,
    'TypeOfLastPlayed': 83,
    'MalignanceActive': 84,
    'EnemyName': 85,
    'IsElite': 86,
    'TextValue': 87,
    'IsChain': 88,
    'CardName': 89,
    'Questflag': 90,
    'CardColor': 91,
    'Swift': 92,
    'HasKeyword': 93,
    'DeckContainsOneCost': 94,
    'DeckContainsOnlyCardsWithKeyword': 95,
    'IsSwift': 96,
    'PlayedCardHasKeyword': 97,
    'EnemyHasObtainableEnchantment': 98,
    'EffigyActive': 99,
    'AlreadyPlayedThisTurn': 100,
    'CanBeUpgraded': 101,
    'TideIsEbb': 102,
    'EvadedLastTurn': 103,
    'IsImprintedCard': 104,
    'LastDrawnCardHasKeyword': 105,
    'IsUpgraded': 106,
    'TotalCardCost': 107,
    'IsFinalBoss': 108,
    'AreaState': 109,
    'Imbued': 110,
    'DeckContainsOnlySuffix': 111
};

export const CONDITION_OPERATOR = {
    'IsLessThan': 0,
    'IsMoreThan': 1,
    'Is': 2,
    'IsNot': 3,
    'IsHigherPercent': 4,
    'IsLowerPercent': 5,
    'IsChance': 6
};